import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import {
  Modal,
  Input,
  Divider,
  Button,
} from 'semantic-ui-react'

import {
  onClose,
  onChangeField,
  submitCreateStoryModal,
} from '_actions/createStoryModal'
import { toast } from 'components/react-semantic-toasts'
import MydClassrooms from 'react-components/myd-classrooms'
import _t from 'utils/i18n_helper'
import { mydWWWOauthUrl } from 'config'


const openNewTab = (url) => {
  let a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'openNewTab')
  document.body.appendChild(a)
  a.click()
}

const MydCreateStoryModal = (props) => {
  const { auth, createStoryModal, onChangeField, onClose, submitCreateStoryModal } = props

  const fCreateStory = () => {
    if (_.isFunction(createStoryModal.onSubmit)) {
      createStoryModal.onSubmit(createStoryModal).then(
        w => {
          openNewTab(mydWWWOauthUrl(`http://library.mydocumenta.com/widgets/${w.id}`))
          onClose()
        }
      ).catch(
        err => {
          toast({
            type: 'error',
            title: 'Ops...',
            description: 'Error saving new story. Please, try again later.',
          })
        }
      )
      return
    }

    submitCreateStoryModal(createStoryModal).then(
      w => {
        openNewTab(mydWWWOauthUrl(`http://library.mydocumenta.com/widgets/${w.id}`))
        onClose()
      }
    ).catch(
      err => {
        toast({
          type: 'error',
          title: 'Ops...',
          description: 'Error saving new story. Please, try again later.',
        })
      }
    )
  }

  let treeNodes = {data: null}
  const treeNodesToShow = (
    ! _.isEmpty(createStoryModal.treeNodes.data) ?
    _.map(createStoryModal.treeNodes.data, i => i.id) :
    'all'
  )

  if (treeNodesToShow !== 'all') {
    treeNodes.data = _.filter(
      auth.treeNodes.data,
      treeNode => (
        treeNode.isLeaf === false ||
        _.includes(treeNodesToShow, treeNode.id)
      )
    )

  } else {
    treeNodes = auth.treeNodes

  }

  return (
    <Modal
      size='mini'
      dimmer='inverted'
      open={ createStoryModal.isOpen }
      onClose={ onClose }
      closeOnDimmerClick={ false }
    >
      <Modal.Header style={{'background':'#3B3431','color':'#fff'}}>{_t('CREATE-STORY-LABEL')}</Modal.Header>
      <Modal.Content>
        <Input
          fluid
          placeholder={_t('INPUT-TITLE-NEW-STORY', true)}
          onChange={ onChangeField }
          name='name'
        />
        {
          ! auth.user.isIndividual &&
          <>
            <Divider hidden/>
            <MydClassrooms
              treeNodes={ treeNodes }
              isLoading={ auth.treeNodes.isFetching }
              onChange={ (e, v) => onChangeField(e, {name: 'classgroup', value: v.value}) }
              selected={ createStoryModal.classgroup }
              multiple={ false }
              styled={ false }
              input
            />
          </>
        }
      </Modal.Content>
      <Modal.Actions>
        <Button negative disabled={ createStoryModal.isSaving } icon='cancel' onClick={ onClose } />
        <Button positive loading={ createStoryModal.isSaving } icon='checkmark' onClick={ fCreateStory } disabled={
          createStoryModal.name === false ||
          createStoryModal.name === '' ||
          (
            _.isNull(createStoryModal.classgroup) &&
            ! auth.user.isIndividual
          ) ||
          createStoryModal.isSaving ?
          true :
          false
        } />
      </Modal.Actions>
    </Modal>
  )
}

export default connect(
  store => ({
    auth: store.auth,
    createStoryModal: store.createStoryModal,
  }),
  dispatch => ({
    onClose: bindActionCreators(onClose, dispatch),
    onChangeField: bindActionCreators(onChangeField, dispatch),
    submitCreateStoryModal: bindActionCreators(submitCreateStoryModal, dispatch),
  })
)(MydCreateStoryModal)
